import React, { useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';
import './PaymentForm.css';

function PaymentForm({ onSuccess, paymentIntentId, isProcessing }) {
  const stripe = useStripe();
  const elements = useElements();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const { error: submitError } = await elements.submit();
      if (submitError) {
        setError(submitError.message);
        setIsSubmitting(false);
        return;
      }

      const { error: confirmError, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/checkout/confirmation`
        },
        redirect: 'if_required'
      });

      if (confirmError) {
        setError(confirmError.message);
        setIsSubmitting(false);
      } else if (paymentIntent && paymentIntent.status === 'succeeded') {
        // Payment succeeded
        onSuccess(paymentIntentId);
      } else {
        setError('Payment processing failed. Please try again.');
        setIsSubmitting(false);
      }
    } catch (err) {
      console.error('Payment error:', err);
      setError('An unexpected error occurred. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <form className="payment-form" onSubmit={handleSubmit}>
      <h2>Payment Information</h2>
      
      <div className="payment-element-container">
        <PaymentElement />
      </div>

      {error && (
        <div className="payment-error" role="alert">
          {error}
        </div>
      )}

      <button
        type="submit"
        className="btn-primary btn-submit"
        disabled={!stripe || isSubmitting || isProcessing}
      >
        {isSubmitting || isProcessing ? 'Processing Payment...' : 'Complete Order'}
      </button>

      <p className="payment-security">
        🔒 Your payment information is secure and encrypted
      </p>
    </form>
  );
}

export default PaymentForm;



